import React from "react";

export default function useListProduits() {
	const [data, setData] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const [error, setError] = React.useState(null);

	const fetchDataProduits = React.useCallback(async () => {
		try {
			const response = await fetch("/api/listProduits");
			if (!response.ok) throw new Error(`Erreur API ${response.status}`);
			const data = await response.json();

			setData(data);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	React.useEffect(() => {
		fetchDataProduits();
	}, [fetchDataProduits]);

	return { data, loading, error, fetchDataProduits };
}
